const controller = function (
	$auth,
	$cordovaAppVersion,
	$ionicDeploy,
	$ionicHistory,
	$ionicLoading,
	$ionicPlatform,
	$ionicPopup,
	$q,
	$rootScope,
	$scope,
	$state,
	$window,
	Compare,
	Customer,
	Language,
	Support,
	User,
) {
	'ngInject'

	var vm = this;

	vm.appInfo = false;
	vm.badges = {};
	vm.badges.support = Support.count;

	$ionicPlatform.ready(function() {
		if(window.cordova) {
			$q.all([
				$cordovaAppVersion.getAppName(),
				$cordovaAppVersion.getPackageName(),
				$cordovaAppVersion.getVersionCode(),
				$cordovaAppVersion.getVersionNumber()
			]).then(function(res) {

				vm.appInfo = {
					name: res[0],
					package: res[1],
					versionCode: res[2],
					versionNumber: res[3]
				}

			}).catch(console.log)
		}
	});

	vm.checkForUpdate = () => {
		$ionicPlatform.ready(function() {
			$ionicDeploy.check().then(function(hasUpdate) {
				if (hasUpdate) {
					return $ionicPopup.confirm({
						title: 'There is a new update!',
						subTitle: 'Would you like to install this update?',
						okType: 'button-assertive'
					}).then(function(res) {
						if (res) {
							return $q.resolve();
						} else {
							return $q.reject();
						}
					});
				} else {
					$ionicPopup.alert({
						title: 'Your version is up to date!',
						okType: 'button-assertive'
					});
					return $q.reject(100);
				}
			}).then(function() {
				$ionicLoading.show();
				return $ionicDeploy.download();
			}).then(function() {
				return $ionicDeploy.extract();
			}).then(function() {
				$ionicDeploy.load();
			}).catch(function(err) {
				$ionicLoading.hide();
			}).finally(function() {
				$ionicLoading.hide();
			});
		});
	}

	vm.changeLanguage = function() {
		var lang = Language.get() == 'nl' ? 'en' : 'nl'; 
		Language.change(lang);
		$window.location.reload(true)
	}

	vm.logout = function() {
		$rootScope.$broadcast('user:logout');
		

		

		if (window.cordova) {
			User.setPushToken().finally(function() {
				return $auth.logout();
			}).then(function() {
				Customer.flush();
				Compare.clear();
				$state.go('login');
			});
		} else {
			$auth.logout().then(function() {
				Customer.flush();
				Compare.clear();
				$state.go('login');
			})
		}
		
	}

	$scope.$on('support:count', function(e, count) {
		vm.badges.more = count;
	})

	vm.toSupport = function() {
		$ionicHistory.nextViewOptions({
			disableAnimate: true,
		});
		$state.go('tab.support');
	}

	vm.clearCompare = function() {
		Compare.clear();
	}
}

export default controller


// WEBPACK FOOTER //
// ./app/components/more/more.controller.js